import React, { useState, useEffect, useRef } from 'react';
import { Button, TextButton } from 'components/buttons'
import { SelfReportingService } from 'services';
import { Intent, MenuItem } from '@blueprintjs/core';
import { NotificationToaster } from "components/notifications";
import PropTypes from 'prop-types';

export function InstantReportButton(
    {
        id = null,
        text = "Download report",
        icon = "download",
        intent = "primary",
        reportId = null,
        buttonType = "Button",
        buttonDisabled,
        onReportDownloadComplete,
        onReportGenerate
    }
) {

    const [downloadingReport, setDownloadingReport] = useState(false);
    const generationCancelTokenSource = useRef();

    function notifyResponse(response) {
        if (response) {
            NotificationToaster.show(
                Intent.SUCCESS,
                "Report has been generated successfully, download will now begin"
            );
        }
        else {
            NotificationToaster.show(
                Intent.DANGER,
                "Could not generate the report. Please try again.");
        }
        setDownloadingReport(false);
        if (onReportDownloadComplete) {
            onReportDownloadComplete();
        }
    }

    useEffect(function () {
        setDownloadingReport(buttonDisabled);
    }, [buttonDisabled])

    useEffect(function () {
        if (reportId != null) {
            SelfReportingService.getInstantReport(reportId, generationCancelTokenSource, notifyResponse);
        }
    }, [reportId]);



    switch (buttonType) {
        case "MenuItem":
            return (
                <MenuItem icon={icon} intent={intent} onClick={onReportGenerate} id={id} disabled={downloadingReport} text={text} />
            );
        case "Link":
            return (
                <TextButton
                    onClick={onReportGenerate}
                    id={id}
                    disabled={downloadingReport}
                >{text}</TextButton>
            );
        case "Button":
        default:
            return (
                <Button icon={icon} intent={intent} onClick={onReportGenerate} id={id} disabled={downloadingReport} text={text} />
            );
    }
}

InstantReportButton.propTypes = {
    id: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    intent: PropTypes.string,
    reportId: PropTypes.number,
    buttonDisabled: PropTypes.bool,
    onReportGenerate: PropTypes.func.isRequired,
    onReportDownloadComplete: PropTypes.func.isRequired,
    buttonType: PropTypes.oneOf(["Button", "Link", "MenuItem"])
};